// extracted by mini-css-extract-plugin
export default {"gallery":"c-g_eU"};